export default __webpack_public_path__ + "static/media/databaseicon.f27e9cec.png";